<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M5 17l3-3 4 4 8-8" stroke-width="2" fill="none" stroke="currentColor" />
    </svg>
</template>
